import PercentChange from '../Layout/Trends.PercentChange';

const isNegative = (value: number) => {
  const sign = Math.sign(value);
  return sign === -1;
};

const displayValue = (metricValue: number | string) => {
  const isNotANumber = Number.isNaN(metricValue) || metricValue === 'NaN';
  const isZero = metricValue === 0;

  return isNotANumber || isZero ? '-' : `${Number(metricValue).toFixed(2)}%`;
};

export const CpaChangeCell = ({
  cpaChange,
}: {
  cpaChange: { flavorCategoryCpaChange: number; brandCpaChange: number };
}) => {
  const { flavorCategoryCpaChange, brandCpaChange } = cpaChange;

  const flavorArrowDirection = isNegative(flavorCategoryCpaChange) ? 'up' : 'down';
  const brandArrowDirection = isNegative(brandCpaChange) ? 'up' : 'down';

  return (
    <PercentChange
      brandChange={displayValue(brandCpaChange)}
      flavorCategoryChange={displayValue(flavorCategoryCpaChange)}
      brandArrowDirection={brandArrowDirection}
      flavorArrowDirection={flavorArrowDirection}
    />
  );
};

export const RoasChangeCell = ({
  roasChange,
}: {
  roasChange: { flavorCategoryRoasChange: number; brandRoasChange: number };
}) => {
  const { flavorCategoryRoasChange, brandRoasChange } = roasChange;

  const flavorArrowDirection = isNegative(flavorCategoryRoasChange) ? 'down' : 'up';
  const brandArrowDirection = isNegative(brandRoasChange) ? 'down' : 'up';

  return (
    <PercentChange
      brandChange={displayValue(brandRoasChange)}
      flavorCategoryChange={displayValue(flavorCategoryRoasChange)}
      brandArrowDirection={brandArrowDirection}
      flavorArrowDirection={flavorArrowDirection}
    />
  );
};
